import { styled } from 'styled-components';

export const PricingCard = styled.div`
  display: flex;
  height: fit-content;
  padding: 24px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 24px;
  border-radius: 12px;
  background-color: ${(props) => props.theme.colors.base};
  flex: 1 1 0;
  min-width: 300px;
`;

export const PricingCardPlanText = styled.p`
  color: ${(props) => props.theme.colors.default[500]};
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%; /* 20px */
  letter-spacing: 0.4px;
  text-transform: uppercase;
`;

export const PricingCardCopyText = styled.div`
  color: ${({ theme }) => theme.colors.primary[900]};
`;

export const PricingTextContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
`;
export const PricingTextWrapper = styled.div`
  color: ${(props) => props.theme.colors.default[900]};
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: 78%;
  display: flex;

  & > p {
    color: ${(props) => props.theme.colors.default[500]};
  }
`;

export const CurrencyContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: ${(props) => props.theme.colors.default[900]};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%; /* 16px */
`;

export const PillContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SplitCard = styled.div`
  display: flex;
  padding: 0 12px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 8px;
  background-color: ${(props) => props.theme.colors.default[50]};
  color: ${(props) => props.theme.colors.default[900]};
  font-size: 16px;
  font-style: normal;
  font-weight: 550;
  line-height: normal;
`;

export const SplitCardItem = styled.p`
  padding: 12px 0;
  width: 100%;

  &:not(:last-of-type) {
    border-bottom: 1px solid ${(props) => props.theme.colors.default[200]};
  }
`;

export const FooterWrapper = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 4px;
  align-self: stretch;
  font-size: 16px;
  font-weight: 550;
  line-height: 100%;
  color: ${({ theme }) => theme.colors.default[400]};

  > span {
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.primary.default};
  }
`;
